import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./SaberMasBtn.css";

const SaberMasButton = ({ 
  to,           // Ruta específica (anula la ruta contextual si se provee)
  onClick,      // Manejo de click personalizado
  children,     // Texto personalizado
  variant = "", // Variante de estilo
  className = "", // Clases adicionales
  context = ""  // Contexto específico (opcional)
}) => {
  const location = useLocation();
  const baseClass = "saber-mas-btn";
  const combinedClass = `${baseClass} ${variant} ${className}`.trim();

  // Determinar la ruta basada en el contexto si no se provee 'to'
  const getContextualRoute = () => {
    switch(context) {
      case "hero":
        return "/nosotros";
      case "card-nosotros":
        return "/nosotros";
      case "card-calidad":
        return "/calidad-certificaciones";
      case "card-etica":
        return "/valores";
      case "card-equipo":
        return "/equipo";
      case "proyecto-paneles":
        return "/paneles-solares-detalle";
      case "proyecto-inmobiliaria":
        return "/promocion-inmobiliaria-detalle";
      case "proyecto-obra-civil":
        return "/obra-civil-detalle";
      default:
        return "/";
    }
  };

  const destination = to || getContextualRoute();

  if (onClick) {
    return (
      <button onClick={onClick} className={combinedClass}>
        {children || "Saber más"}
      </button>
    );
  }

  return (
    <Link 
      to={destination} 
      className={combinedClass}
      state={{ from: location.pathname }}
    >
      {children || "Saber más"}
    </Link>
  );
};

export default SaberMasButton;